module.exports = __webpack_public_path__ + "media/images/phone/header-bookshelf@3x-f55e3faa0cf54cf7c93f4dd5dce362fe.png";